"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./JobPosting.scss");
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
var _interalExternalArrows = require("../../utils/interalExternalArrows");
var _Button = _interopRequireDefault(require("../Button/Button"));
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const JobPosting = _ref => {
  let {
    content = {}
  } = _ref;
  const {
    description,
    title,
    postedDate,
    timeType,
    jobFamily,
    applyURL,
    compensationMidpoint,
    compensationMinimum,
    country,
    region,
    municipality,
    requisitionId,
    benefitsClause,
    compensationClause,
    bonusEligibility,
    eeoClause
  } = content;
  const {
    mouse
  } = (0, _useMouse.default)();
  const formatter = new Intl.NumberFormat();
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "ter-job-posting"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-job-posting__border ter-job-posting__border--yellow"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-job-posting__border ter-job-posting__border--blue--cover"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-job-posting__border ter-job-posting__border--blue"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-job-posting--content"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "ter-job-posting__title"
  }, title), /*#__PURE__*/_react.default.createElement("ul", {
    className: "ter-job-posting__details"
  }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("b", null, "Posted |"), /*#__PURE__*/_react.default.createElement("pre", null, " "), ` ${postedDate}`), timeType && /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("b", null, timeType, " |"), /*#__PURE__*/_react.default.createElement("pre", null, " "), ` ${requisitionId}`), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("b", null, "Category |"), /*#__PURE__*/_react.default.createElement("pre", null, " "), `${jobFamily}`), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("b", null, "Location | "), /*#__PURE__*/_react.default.createElement("pre", null, " "), ` ${municipality}, ${region ? region + ", " : ""}  ${country}`, " ", /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-job-posting__details--break"
  }), /*#__PURE__*/_react.default.createElement("b", null, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    className: mouse ? "" : "tabFocus",
    tabIndex: mouse ? "" : "0",
    to: ` https://www.google.com/maps/place/${municipality}${region ? "+" + region : ""}+${country}`
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-job-posting__details--map"
  }, "View map")), (0, _interalExternalArrows.arrowDiagonalRight)()))), /*#__PURE__*/_react.default.createElement(_Button.default, {
    url: applyURL,
    text: "Apply Now",
    className: `ter-job-posting__button ter-button--primary--1`,
    external: true
  }), /*#__PURE__*/_react.default.createElement("section", {
    className: "ter-job-posting__description"
  }, /*#__PURE__*/_react.default.createElement("h6", null, "Summary"), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-job-posting__description--text",
    dangerouslySetInnerHTML: {
      __html: description.description
    }
  })), compensationMidpoint && compensationMinimum ? /*#__PURE__*/_react.default.createElement("section", {
    className: "ter-job-posting__pay-equity"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-job-posting__pay-equity--title"
  }, "Pay Equity"), compensationClause && /*#__PURE__*/_react.default.createElement("p", null, compensationClause.compensationClause), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-job-posting__pay-equity--compensation"
  }, /*#__PURE__*/_react.default.createElement("b", null, "Hiring Range |"), /*#__PURE__*/_react.default.createElement("pre", null, " "), /*#__PURE__*/_react.default.createElement("p", null, `$${formatter.format(compensationMinimum)} - $${formatter.format(compensationMidpoint)}`)), bonusEligibility && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-job-posting__pay-equity--compensation"
  }, /*#__PURE__*/_react.default.createElement("b", null, "Bonus Eligible | "), /*#__PURE__*/_react.default.createElement("pre", null, " "), /*#__PURE__*/_react.default.createElement("p", null, bonusEligibility)), benefitsClause && /*#__PURE__*/_react.default.createElement("p", null, benefitsClause.benefitsClause), eeoClause && /*#__PURE__*/_react.default.createElement("p", null, eeoClause.eeoClause)) : "", /*#__PURE__*/_react.default.createElement(_Button.default, {
    url: applyURL,
    text: "Apply Now",
    className: `ter-job-posting__button ter-button--primary--1`,
    external: true
  })));
};
var _default = JobPosting;
exports.default = _default;